export const menuData = {
    modules: [
        {
            name: 'master',
            displayName: 'Master',
            code: '2',
            path: '/masters',
            childrens: [
                {
                    name: 'user',
                    displayName: 'User',
                    code: '2_1',
                    component: 'user',
                    path: '/masters/user',
                    childrens: [{
                        name: 'userManagement',
                        displayName: 'View / Acitvate User',
                        code: '2_1_1',
                        component: 'UserManagement',
                        pCode: '2011'
                    },
                    {
                        name: 'editRolesRights',
                        displayName: "Edit Role's Rights",
                        code: '2_1_2',
                        component: 'EditRoles',
                        pCode: '2012'
                    }],
                    pCode: '201'
                },
                {
                    name: 'categoryMaster',
                    displayName: 'Category',
                    code: '2_2',
                    component: 'category',
                    path: '/masters/category',
                    childrens: [{
                        name: 'jobCategory',
                        displayName: 'Job Category',
                        code: '2_2_1',
                        component: 'JobCategory',
                        pCode: '202'
                    },
                    {
                        name: 'itemCategory',
                        displayName: "Item Category",
                        code: '2_2_2',
                        component: 'ItemCategory',
                        pCode: '202'
                    },
                    {
                        name: 'taskCategory',
                        displayName: "Task Category",
                        code: '2_2_3',
                        component: 'TaskCategory',
                        pCode: '202'
                    },
                    ],
                    pCode: '202'
                },
                {
                    name: 'brandMaster',
                    displayName: 'Brand',
                    code: '2_3',
                    component: 'brand',
                    path: '/masters/brand',
                    childrens: [],
                    pCode: '203'
                },
                {
                    name: 'itemMaster',
                    displayName: 'Item',
                    code: '2_4',
                    component: 'item',
                    path: '/masters/item',
                    childrens: [],
                    pCode: '204'
                },
                {
                    name: 'taskMaster',
                    displayName: 'Task',
                    code: '2_5',
                    component: 'task',
                    path: '/masters/task',
                    childrens: [],
                    pCode: '205'
                },
                {
                    name: 'staffDesignationMaster',
                    displayName: 'Staff Designation',
                    code: '2_6',
                    component: 'staffDesignation',
                    path: '/masters/staff-designation',
                    childrens: [],
                    pCode: '206'
                },
                {
                    name: 'staffMaster',
                    displayName: 'Staff',
                    code: '2_7',
                    component: 'staff',
                    path: '/masters/staff',
                    childrens: [],
                    pCode: '207'
                },
                {
                    name: 'storeMaster',
                    displayName: 'Store',
                    code: '2_8',
                    component: 'store',
                    path: '/masters/store',

                    childrens: [],
                    pCode: '208'
                },
                {
                    name: 'vendorMaster',
                    displayName: 'Vendor',
                    code: '2_9',
                    component: 'vendor',
                    path: '/masters/vendor',
                    childrens: [],
                    pCode: '209'
                },
                {
                    name: 'BatteryMaster',
                    displayName: 'Battery Master',
                    code: '2_10',
                    component: 'battery',
                    path: '/masters/battery',
                    childrens: [],
                    pCode: '210'
                },
                {
                    name: 'serviceTaskMaster',
                    displayName: 'Service Task',
                    code: '2_11',
                    component: 'serviceTask',
                    path: '/masters/service-task',
                    childrens: [],
                    pCode: '211'
                },
                {
                    name: 'fuelMaster',
                    displayName: 'Fuel Master',
                    code: '2_12',
                    component: 'fuel',
                    path: '/masters/fuel',
                    childrens: [],
                    pCode: '212'
                },
                {
                    name: 'vehicleMapping',
                    displayName: 'Vehicle Branch Mapping',
                    code: '2_13',
                    component: 'vehicleBranchMapping',
                    path: '/masters/vehicle-branch-mapping',
                    childrens: [],
                    pCode: '213'
                },
                {
                    name: 'repairItemConfig',
                    displayName: 'Repair Item Config',
                    code: '2_14',
                    component: 'repairItemConfig',
                    path: '/masters/repair-item-config',
                    childrens: [],
                    pCode: '214'
                },
                 {
                    name: 'companyPOTNC',
                    displayName: 'Company PO TNC',
                    code: '2_15',
                    component: 'companyPOTNC',
                    path: '/masters/company-po-tnc',
                    childrens: [],
                    pCode: '215'
                },
                 {
                    name: 'inventoryThresholdRules',
                    displayName: 'Inventory Threshold Rules',
                    code: '2_16',
                    component: 'inventoryThresholdRules',
                    path: '/masters/inventory-threshold-rules',
                    childrens: [],
                    pCode: '216'
                }

            ],
            pCode: '2'
        },
        {
            name: 'transaction',
            displayName: 'Transactions',
            code: '3',
            path: '/transactions',
            childrens: [
                {
                    name: 'jobCard',
                    displayName: 'Job Cards',
                    code: '3_1',
                    component: 'jobCard',
                    path: '/transactions/job-cards',
                    childrens: [],
                    pCode: '301'
                },
                {
                    name: 'issueInventory',
                    displayName: 'Issue Inventory',
                    code: '3_2',
                    component: 'issueInventory',
                    path: '/transactions/issue-inventory',
                    childrens: [],
                    pCode: '302'
                },
                {
                    name: 'purchaseOrder',
                    displayName: 'Purchase Order',
                    code: '3_3',
                    component: 'purchaseOrder',
                    path: '/transactions/purchase-order',
                    childrens: [],
                    pCode: '303'
                },
                {
                    name: 'purchaseInvoice',
                    displayName: 'Purchase Invoice',
                    code: '3_4',
                    component: 'purchaseInvoice',
                    path: '/transactions/purchase-invoice',
                    childrens: [],
                    pCode: '304'
                },
                {
                    name: 'purchaseReturn',
                    displayName: 'Purchase Return',
                    code: '3_9',
                    component: 'purchaseReturn',
                    path: '/transactions/purchaseReturn',
                    childrens: [],
                    pCode: '309'
                },
                {
                    name: 'serviceCalender',
                    displayName: 'Service Calender',
                    code: '3_5',
                    component: 'serviceCalender',
                    path: '/transactions/serviceCalender',
                    childrens: [],
                    pCode: '305'
                },
                {
                    name: 'inventoryTransfer',
                    displayName: 'Inventory Transfer',
                    code: '3_6',
                    component: 'inventoryTransfer',
                    path: '/transactions/inventory-transfer',
                    childrens: [
                        //     {
                        //     name:'outwardInventoryTransfer',
                        //     displayName:'Outward Inventory Transfer',
                        //     code:'3_5_1',
                        //     component:'outwardInventoryTransfer',
                        //     pCode:'305'
                        // },
                        // {
                        //     name:'inwardInventoryTransfer',
                        //     displayName:"Inward Inventory Transfer",
                        //     code:'3_5_2',
                        //     component:'inwardInventoryTransfer',
                        //     pCode:'305'
                        // },
                    ],
                    pCode: '306'
                },
                {
                    name: 'externalTransferRepair',
                    displayName: 'External Transfer Repair',
                    code: '3_6_3',
                    component: 'externalTransferRepair',
                    path: '/transactions/external-transfer-repair',
                    pCode: '306'
                },
                {
                    name: 'fuelVoucher',
                    displayName: 'Fuel Voucher',
                    code: '3_7',
                    component: 'fuelVoucher',
                    path: '/transactions/fuelVoucher',
                    childrens: [],
                    pCode: '307'
                },
                {
                    name: 'processVoucher',
                    displayName: 'Process Voucher',
                    code: '3_8',
                    component: 'processVoucher',
                    path: '/transactions/processVoucher',
                    childrens: [],
                    pCode: '308'
                },
            ],
            pCode: '3'
        },
        {
            name: 'reports',
            displayName: 'Reports',
            code: '4',
            path: '/reports',
            childrens: [
                {
                    name: 'closingStockSummary',
                    displayName: 'Closing Stock Summary',
                    code: '4_1',
                    component: 'closingStockSummary',
                    path: '/reports/closing-stock-summary',
                    childrens: [],
                    pCode: '401'
                },
                {
                    name: 'itemTransactionLog',
                    displayName: 'Item Transaction Report',
                    code: '4_2',
                    component: 'itemTransactionLog',
                    path: '/reports/item-transaction-log',
                    childrens: [],
                    pCode: '402'
                },
                {
                    name: 'vehiclewiseConsumptionReport',
                    displayName: 'Vehiclewise Consumption Report',
                    code: '4_3',
                    component: 'vehiclewiseConsumptionReport',
                    path: '/reports/vehiclewise-consumption-report',
                    childrens: [],
                    pCode: 403
                },
                {
                    name: 'vehiclewiseConsumptionQuickViewReport',
                    displayName: 'Vehiclewise Consumption Quick View Report',
                    code: '4_4',
                    component: 'vehiclewiseConsumptionQuickViewReport',
                    path: '/reports/vehiclewise-consumption-quick-view-report',
                    childrens: [],
                    pCode: 404
                },
                {
                    name: 'JobCardReport',
                    displayName: 'Job Card Report',
                    code: '4_5',
                    component: 'JobCardReport',
                    path: '/reports/job-card-report',
                    childrens: [],
                    pCode: 405
                },
                {
                    name: 'JobCardTask',
                    displayName: 'Job Card Task Report',
                    code: '4_6',
                    component: 'JobCardTask',
                    path: '/reports/job-card-task',
                    childrens: [],
                    pCode: 406
                },
                {
                    name: 'BatteryReport',
                    displayName: 'Battery Report',
                    code: '4_7',
                    component: 'BatteryReport',
                    path: '/reports/battery-report',
                    childrens: [],
                    pCode: 407
                },
                {
                    name: 'FuelReport',
                    displayName: 'Fuel Report',
                    code: '4_8',
                    component: 'FuelReport',
                    path: '/reports/fuel-report',
                    childrens: [],
                    pCode: 408
                },
                {
                    name: 'PurchaseOrderReport',
                    displayName: 'Purchase Order Report',
                    code: '4_9',
                    component: 'PurchaseOrderReport',
                    path: '/reports/purchaseorder-report',
                    childrens: [],
                    pCode: 409
                },
                {
                    name: 'PurchaseInvoiceReport',
                    displayName: 'Purchase Invoice Report',
                    code: '4_10',
                    component: 'PurchaseInvoiceReport',
                    path: '/reports/purchaseinvoice-report',
                    childrens: [],
                    pCode: 410
                },
                {
                    name: 'ItemIssueRegisterReport',
                    displayName: 'Item Issue Register Report',
                    code: '4_11',
                    component: 'ItemIssueRegisterReport',
                    path: '/reports/itemissueregister-report',
                    childrens: [],
                    pCode: 411
                },
                {
                    name: 'SrNoWiseItemHistory',
                    displayName: 'S/r No Wise Item History',
                    code: '4_12',
                    component: 'SrNoWiseItemHistory',
                    path: '/reports/srno-wise-item-history',
                    childrens: [],
                    pCode: 412
                },
                {
                    name: 'TyreReport',
                    displayName: 'Tyre Report',
                    code: '4_13',
                    component: 'TyreReport',
                    path: '/reports/tyre-report',
                    childrens: [],
                    pCode: 413
                },
                {
                    name: 'RepairReport',
                    displayName: 'Repair Report',
                    code: '4_14',
                    component: 'RepairReport',
                    path: '/reports/repair-report',
                    childrens: [],
                    pCode: 414
                },
            ],
            pCode: '4'
        },
        {
            name: 'communication',
            displayName: 'Communication',
            code: '5',
            path: '/communication',
            childrens: [
                {
                    name: 'sms',
                    displayName: 'SMS',
                    code: '5_1',
                    component: 'sms',
                    path: '/communication/sms',
                    childrens: [],
                    pCode: '501'
                },
                /* {
                    name: 'whatsapp',
                    displayName: 'Whatsapp',
                    code: '5_2',
                    component: 'whatsapp',
                    path: '/communication/whatsapp',
                    childrens: [],
                    pCode: '502',
                }, */
            ],
            pCode: '5'
        },

    ]
}


/* {
    name:'dashboard',
    displayName:'Dashboard',
    code:'1',
    path:'/dashboard',
    childrens:[],
    pCode:'1'
},{
    name:'configs',
    displayName:'Configs',
    code:'5',
    path:'/configs',
    childrens:[
        {
            name:'jobCardConfig',
            displayName:'Job Card Config',
            code:'5_1',
            component:'jobCardConfig',
            path:'/configs/job-card-config',
            childrens:[],
            pCode:'501'
        },
        {
            name:'purchaseConfig',
            displayName:'Purchase Config',
            code:'5_2',
            component:'purchaseConfig',
            path:'/configs/purchase-config',
            childrens:[],
            pCode:'502'
        }
    ],
    pCode:'5'
} */